module.exports = __webpack_public_path__ + "img/bsfq-mobile-2.c9cd4122.svg";